export const APPLICATIONS_GET = 'APPLICATIONS_GET'

export const CHANGE_APPLICATION_FETCH = 'CHANGE_APPLICATION_FETCH'
export const CHANGE_APPLICATION_SUCCESS = 'CHANGE_APPLICATION_SUCCESS'
export const CHANGE_APPLICATION_FAILED = 'CHANGE_APPLICATION_FAILED'

export const SET_APPLICATION_LOGO = 'SET_APPLICATION_LOGO'
export const SET_APPLICATION_LOGO_SUCCESS = 'SET_APPLICATION_LOGO_SUCCESS'
export const SET_APPLICATION_LOGO_FAILED = 'SET_APPLICATION_LOGO_FAILED'

export const CALL_USERS_FETCH = 'CALL_USERS_FETCH'
export const CALL_USERS_SUCCESS = 'CALL_USERS_SUCCESS'
export const CALL_USERS_FAILED = 'CALL_USERS_FAILED'

export const PUBLIC_ACCESS_FETCH = 'PUBLIC_ACCESS_FETCH'
export const PUBLIC_ACCESS_SUCCESS = 'PUBLIC_ACCESS_SUCCESS'
export const PUBLIC_ACCESS_FAILED = 'PUBLIC_ACCESS_FAILED'

export const SENDER_CREATE = 'SENDER_CREATE'
export const SENDER_CREATE_SUCCESS = 'SENDER_CREATE_SUCCESS'
export const SENDER_CREATE_FAILED = 'SENDER_CREATE_FAILED'

export const SENDER_DELETE = 'SENDER_DELETE'
export const SENDER_DELETE_SUCCESS = 'SENDER_DELETE_SUCCESS'
export const SENDER_DELETE_FAILED = 'SENDER_DELETE_FAILED'

export const SENDER_VERIFY = 'SENDER_VERIFY'
export const SENDER_VERIFY_SUCCESS = 'SENDER_VERIFY_SUCCESS'
export const SENDER_VERIFY_FAILED = 'SENDER_VERIFY_FAILED'

export const USERS_FETCH = 'USERS_FETCH'
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS'
export const USERS_FETCH_FAILED = 'USERS_FETCH_FAILED'

export const USER_UPDATE = 'USER_UPDATE'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAILED = 'USER_UPDATE_FAILED'

export const USER_DELETE = 'USER_DELETE'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_FAILED = 'USER_DELETE_FAILED'

export const SET_APPLICATION_NAME = 'SET_APPLICATION_NAME'
export const SET_APPLICATION_NAME_SUCCESS = 'SET_APPLICATION_NAME_SUCCESS'
export const SET_APPLICATION_NAME_FAILED = 'SET_APPLICATION_NAME_FAILED'

export const SET_OWNER = 'SET_OWNER'
export const SET_OWNER_SUCCESS = 'SET_OWNER_SUCCESS'
export const SET_OWNER_FAILED = 'SET_OWNER_FAILED'
